<template>
	<div
		class="ds-app-container"
		v-loading="menuLoading"
	>
		<LeftMenu v-if="!menuLoading"></LeftMenu>
		<div
			v-if="!menuLoading"
			class="ds-center-render"
		>
			<Nav @appChangeShow="appChangeShow"></Nav>
			<RightRouterView></RightRouterView>

			<transition
				
				enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut"
			>
				<AppChange
					:showClose="true"
					@closeAppChange="closeAppChange"
					v-if="appChnageShow==true"
				></AppChange>
			</Transition>

		</div>
	</div>
</template>

<script>
import Nav from "./Nav";
//侧边栏目
import LeftMenu from "./LeftMenu";
//右边路由容器
import RightRouterView from "./RightRouterView";
import AppChange from "@/basicLayout/AppChange.vue";
import { getApplicationCode } from "@/utils/user";

export default {
	data() {
		return {
			appChnageShow: false,
			appCode: getApplicationCode(),
		};
	},
	components: {
		LeftMenu,
		AppChange,
		Nav,
		RightRouterView,
	},
	computed: {
		menuLoading() {
			return this.$store.state.app.menuLoading;
		},
	},
	async created() {
		this.$store.dispatch("app/changeMenuLoading", true);
			await this.$store.dispatch("app/getMenuList");
		if (this.appCode == "logistics") {
			await this.$store.dispatch("app/getAllowOrg");
		}
		
		this.$store.dispatch("app/changeMenuLoading", false);
		//退出登录事件
		window.addEventListener("http_error_event", async (event) => {
			if (event.detail.type == "loginOut") {
				await this.$store.dispatch("upms/loginOut");
				this.$router.replace({
					name: "login",
				});
			}
		});
	},
	methods: {
		appChangeShow() {
			this.appChnageShow = true;
		},
		closeAppChange() {
			this.appChnageShow = false;
		},
	},
};
</script>

<style lang='scss' scoped>
.ds-app-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	.ds-center-render {
		flex: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
}
.footer-power {
	text-align: center;
	font-size: 14px;
	padding-top: 10px;
	padding-bottom: 10px;
	color: rgba($color: #000000, $alpha: 0.56);
}
</style>